// extracted by mini-css-extract-plugin
module.exports = {"content":"AuthorizeToLogin_content__3wLtG","sendOtp":"AuthorizeToLogin_sendOtp__3zC6h"};